// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"4rem","rowPadding":"1rem"};